import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'

export const withdrawUser = async (): Promise<{ success: boolean; userId?: string }> => {
  try {
    const withdrawUserFunction = httpsCallable(functions, 'withdraw_user')
    const result = await withdrawUserFunction()
    return result.data as { success: boolean; userId?: string }
  } catch (error) {
    console.error('[withdrawUser] Error:', error)
    throw error
  }
}
